import {UIService} from "../UIService";
import {ConfiguratorHeaderService} from "./configuratorHeaderService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {AppStateService} from "../../services/appStateService";
import {ShapeService} from "../../services/shapeService";
import {ShapeInterface} from "../drawingComponent/interface/shapeInterface";
import Cookies from 'js-cookie';
import {BasementWindowRulesService} from "../../services/basementWindowRulesService";
import {AccessoryRuleService} from "../../services/accessoryRuleService";
import {CustomDimensionColorRuleService} from "../../services/customDimentionColorRuleService";
import {HandleUIService} from "../handleComponent/handleUIService";
import {EventService} from "../../services/eventService";
import {PriceService} from "../../services/priceService";

/**
 * Please note that bottom panel size in reality is the glass size we choose
 * So in the end bottom pvc panel size = product height - bottom panel size
 * I don't know why is like this but for now I don't want to refactor this part
 * Yes, I know it's stupid...
 */

/**
 * we have to remember that pricelist are in mm and user can choose sizes also in dm (from which we substract 20mm for montage)
 * so if minimal size in pricelist is for example 488mm user can't choose 5dm because 5dm = 500mm - 20mm = 480mm, so minimal size will be 6dm
 * the same with height - if max is 1570mm user can choose additional size - 16dm because 16dm = 1600mm - 20mm = 1580mm
 */

export class ConfiguratorHeaderUIService {
    private readonly FULL_GLASS_OPTION: string = 'Helglas';
    private readonly CASEMENT_WINDOW_FUNCTION_ID = 11;
    private readonly TOP_HANDLE_POSITION_ID = 3;
    private readonly BOTTOM_HINGE_SIDE_ID = 3;
    private readonly BOTH_SIDE_ACTIVE_SASH_ID = 3;

    private UIService: UIService;
    private configuratorHeaderService: ConfiguratorHeaderService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private appStateService: AppStateService;
    private shapeService: ShapeService;
    private handleUIService: HandleUIService;
    private accessoryRulesService: AccessoryRuleService;
    private customDimensionColorRuleService: CustomDimensionColorRuleService;
    private eventService: EventService;
    private priceService: PriceService;

    constructor() {
        this.UIService = new UIService();
        this.configuratorHeaderService = new ConfiguratorHeaderService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.appStateService = new AppStateService();
        this.shapeService = new ShapeService();
        this.handleUIService = new HandleUIService();
        this.accessoryRulesService = new AccessoryRuleService();
        this.customDimensionColorRuleService = new CustomDimensionColorRuleService();
        this.eventService = new EventService();
        this.priceService = new PriceService();
    }

    public initializeConfiguratorHeader()
    {
        this.initializeQuantity();
        this.initUnitsModule();

        switch (this.productDataStore.getProductShape()) {
            case 'rectangle':
            case 'triangle':
            case 'arc':
                this.initDefaultSizesModule();
                break;
            case 'circle':
                this.initCircleSizesModule();
                break;
            case 'polygon':
                this.initPolygonSizesModule();
                this.initPolygonPredefinedShapes();
                break;
        }

        if (this.productDataService.hasFlashingOptions()) {
            this.initFlashingOptions();
        }

        if (this.productDataService.canHaveHingeSideOption()) {
            this.initHingeSideOption();
        }

        if (this.productDataService.isTriangleProduct()) {
            this.initAngleSideOption();
        }

        this.setDefaultColorBasedOnAssociation();
        this.initializeSaveAssociatedProductUrl();

        this.initDimensionInfoModal();
        this.initCasementWindowModal();

        if (this.appStateService.getAppSettingOption('iccDrawing')) {
            this.initializeIccDrawingSide();
        }

        this.clearDimensionsFromDifferentSerieLocalStorage();
        this.validateBasementWindowRule();

        this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'loadingParameterOverlay', false);
        this.UIService.refreshTemplate('configuratorHeader');
    }

    private initializeIccDrawingSide()
    {
        const isDefaultOutsideView = !this.productDataStore.getAttributeByName('defaultInsideView');

        if (isDefaultOutsideView) {
            this.UIService.updateDrawingSide('outer');
            new EventService().emit("reloadDrawing");
        }
    }

    private initHingeSideOption()
    {
        const hingeOptionSelector: any = this.UIService.getElementByAttribute('nf-template-input', 'productHingeSideOption');
        const hingeType = this.UIService.getAttributeFromElement(hingeOptionSelector, 'nf-option-name');

        if (hingeType === null) {
            return;
        }
        const hingeOptions: Array<any> = this.productDataStore.getAvailableOptionsByName(hingeType).sort((a, b) => {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            // a must be equal to b
            return 0;
        }).map((hinge) => {
            return {
                'name': hinge.attributes.name,
                'value': hinge.id,
            };
        });

        let selectedHingeOptionId = this.productDataStore.getSelectedOptionData(hingeType).id;

        const initialDimensionsBasedOnAnotherSerie = this.getDimensionsFromDifferentSerie();
        if (initialDimensionsBasedOnAnotherSerie && initialDimensionsBasedOnAnotherSerie.hingeSide) {
            selectedHingeOptionId = initialDimensionsBasedOnAnotherSerie.hingeSide;
            this.productDataService.updateSelectedOptionByName(hingeType, selectedHingeOptionId, false, true);
        }

        this.UIService.replaceSelectOptions(hingeOptionSelector, hingeOptions, selectedHingeOptionId);


        hingeOptionSelector.addEventListener('change', event => {
            const hingeOptionSelectorValue: any = parseInt(event.target.value);
            this.productDataService.updateSelectedOptionByName(hingeType, parseInt(hingeOptionSelectorValue), false, true);

            /**
             * If You wonder why it's like that... well, on two sash inside windows we have floating divider so there is
             * only one active sash... but the customer can choose "both side active" so we need to add additional
             * handle for calculations
             */
            if (hingeType === 'activeSash') {
                const defaultHandleQuantity = this.productDataStore.getAttributeByName('handleQuantityDefault');
                if (hingeOptionSelectorValue === this.BOTH_SIDE_ACTIVE_SASH_ID) {
                    this.productDataStore.setAttributeByName('handleQuantity', defaultHandleQuantity * 2);
                } else {
                    this.productDataStore.setAttributeByName('handleQuantity', defaultHandleQuantity);

                }
            }

        });
    }

    private updateHingeSideSelector()
    {
        const hingeOptionSelector: any = this.UIService.getElementByAttribute('nf-template-input', 'productHingeSideOption');
        const hingeType = this.UIService.getAttributeFromElement(hingeOptionSelector, 'nf-option-name');

        if (hingeType === null) {
            return;
        }
        const hingeOptions: Array<any> = this.productDataStore.getAvailableOptionsByName(hingeType).sort((a, b) => {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            // a must be equal to b
            return 0;
        }).map((hinge) => {
            return {
                'name': hinge.attributes.name,
                'value': hinge.id,
            };
        });

        const selectedHingeOptionId = this.productDataStore.getSelectedOptionData(hingeType).id;
        this.UIService.replaceSelectOptions(hingeOptionSelector, hingeOptions, selectedHingeOptionId);
    }

    private initAngleSideOption()
    {
        const angleSideSelector: any = this.UIService.getElementByAttribute('nf-template-input', 'productAngleSideOption');
        const angleSideOptions: Array<any> = this.productDataStore.getAvailableOptionsByName('angleSide').sort((a, b) => {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            // a must be equal to b
            return 0;
        }).map((angleSide) => {
            return {
                'name': angleSide.attributes.name,
                'value': angleSide.id,
            };
        });

        const selectedAngleSideOptionId = this.productDataStore.getSelectedOptionData('angleSide').id;
        this.UIService.replaceSelectOptions(angleSideSelector, angleSideOptions, selectedAngleSideOptionId);


        angleSideSelector.addEventListener('change', event => {
            const angleSideSelector: any = event.target;
            this.productDataService.updateSelectedOptionByName('angleSide', parseInt(angleSideSelector.value));
            this.productDataService.mirrorTriangleShape();
            this.productDataService.updateProductDrawing();
        });
    }

    private initFlashingOptions()
    {
        const flashingOptionsSelector: HTMLInputElement = this.UIService.getTemplateInput('selectFlashingOption');

        flashingOptionsSelector.addEventListener('change', (event: any) => {
            const flashingSelector: any = event.target;
            this.productDataService.updateSelectedOptionByName('flashing', parseInt(flashingSelector.value));
        });
    }

    private initDimensionInfoModal()
    {
        const showModalInput = this.UIService.getElementByAttribute('nf-template-action', 'showDimensionInfoModal');
        const closeModalInput = this.UIService.getElementByAttribute('nf-template-action', 'closeDimensionInfoModal');

        showModalInput.addEventListener('click', (event: any) => {
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'showDimensionInfoModal', true);
            this.UIService.refreshTemplate('configuratorHeader');

        })

        closeModalInput.addEventListener('click', (event: any) => {
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'showDimensionInfoModal', false);
            this.UIService.refreshTemplate('configuratorHeader');
        })
    }

    private initCasementWindowModal()
    {
        const closeModalInput = this.UIService.getElementByAttribute('nf-template-action', 'closeCasementWindowModal');

        closeModalInput.addEventListener('click', (event: any) => {
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'casementWindowModal', false);
            this.UIService.refreshTemplate('configuratorHeader');
        })
    }

    private initUnitsModule()
    {
        const units = this.UIService.getElementsByAttribute('nf-template-action', 'selectDimensionsUnit');
        let selectedUnit = this.productDataStore.getSelectedOptionData('unit');

        const initialDimensionsBasedOnAnotherSerie = this.getDimensionsFromDifferentSerie();
        if (initialDimensionsBasedOnAnotherSerie && initialDimensionsBasedOnAnotherSerie.unit) {
            selectedUnit = this.productDataStore.getAvailableOptionByNameAndId('unit', initialDimensionsBasedOnAnotherSerie.unit);
        }

        // we need to update these selectors because we can edit the product and selected unit can be different from default
        this.updateDimensionUnitSelector(selectedUnit.id);

        units.forEach((unit) => {
            unit.addEventListener('click', (event: any) => {
                this.selectDimensionsUnit.bind(this)(event.target);
            });
        })
    }

    private initDefaultSizesModule(): void
    {
        // @todo: get associated sizes and apply here
        let initialWidthInMillimeter = this.productDataStore.getAttributeByName('width');
        let initialHeightInMillimeter = this.productDataStore.getAttributeByName('height');
        let selectedUnit = this.productDataStore.getSelectedOptionData('unit');
        let initialBottomPanelSize = null;
        const sashConfiguration = this.productDataStore.getSashConfiguration();

        if (this.productDataService.isEntranceDoor()) {
            if (sashConfiguration.defaultWidth) {
                initialWidthInMillimeter = sashConfiguration.defaultWidth;
            }
            if (sashConfiguration.defaultHeight) {
                initialHeightInMillimeter = sashConfiguration.defaultHeight;
            }
        }
        const initialDimensionsBasedOnAnotherSerie = this.getDimensionsFromDifferentSerie();

        if (initialDimensionsBasedOnAnotherSerie) {
            initialWidthInMillimeter = initialDimensionsBasedOnAnotherSerie.width ?? initialWidthInMillimeter;
            initialHeightInMillimeter = initialDimensionsBasedOnAnotherSerie.height ?? initialHeightInMillimeter;
            initialBottomPanelSize = initialDimensionsBasedOnAnotherSerie.bottomPanel ?? initialBottomPanelSize;
            selectedUnit = this.productDataStore.getAvailableOptionByNameAndId('unit', initialDimensionsBasedOnAnotherSerie.unit) ?? selectedUnit;
        }
        const predefinedWidthsSelector = this.UIService.getTemplateInput('productPredefinedWidth');
        const predefinedHeightsSelector = this.UIService.getTemplateInput('productPredefinedHeight');
        const customWidthSelector = this.UIService.getTemplateInput('productCustomWidth');
        const customHeightSelector = this.UIService.getTemplateInput('productCustomHeight');
        const predefinedBottomPanelSelector = this.UIService.getTemplateInput('predefinedBottomPanelSize');
        const customBottomPanelSelector = this.UIService.getTemplateInput('customBottomPanelSize');

        this.updateDimensionSelectorsTemplateFlags(selectedUnit.attributes.type);

        const initialDimensionsBasedOnAssociatedProduct = this.getDimensionsBasedOnAssociatedProductSize();

        if (initialDimensionsBasedOnAssociatedProduct) {
            initialWidthInMillimeter = initialDimensionsBasedOnAssociatedProduct.width;
            initialHeightInMillimeter = initialDimensionsBasedOnAssociatedProduct.height;
        }

        if (selectedUnit.attributes.type === 'module') {
            let dmWidth;
            let mmWidth;
            let dmHeight;
            let mmHeight;

            dmWidth = this.configuratorHeaderService.getWidthInDecimeterBasedOnMillimeters(initialWidthInMillimeter);

            if (selectedUnit.attributes.unit === 'dm') {
                mmWidth = this.configuratorHeaderService.calculateMillimetersFromDecimeters(dmWidth);
            } else {
                mmWidth = dmWidth;
            }
            const widths = this.configuratorHeaderService.getAvailableWidths();

            this.UIService.replaceSelectOptions(predefinedWidthsSelector, widths);
            predefinedWidthsSelector.value = dmWidth.toString();
            this.productDataService.updateProductWidth(mmWidth);

            dmHeight = this.configuratorHeaderService.getHeightInDecimeterBasedOnMillimeters(dmWidth, initialHeightInMillimeter);

            if (selectedUnit.attributes.unit === 'dm') {
                mmHeight = this.configuratorHeaderService.calculateMillimetersFromDecimeters(dmHeight);
            } else {
                mmHeight = dmHeight;
            }
            const heights = this.configuratorHeaderService.getAvailableHeightsByWidth(dmWidth);
            heights.sort((a, b) => a - b);
            this.UIService.replaceSelectOptions(predefinedHeightsSelector, heights);
            predefinedHeightsSelector.value = dmHeight.toString();
            this.productDataService.updateProductHeight(mmHeight);

            if (this.productDataService.canHaveBottomPanel()) {
                 const bottomPanelSizes = this.configuratorHeaderService.getAvailableBottomPanelSizes(
                    dmHeight,
                    this.productDataStore.getAttributeByName('minBottomPanel')
                );
                let decimeterBottomSize: any = this.FULL_GLASS_OPTION;
                const millimeterBottomPanel = this.productDataStore.getAttributeByName('bottomPanel');

                if (millimeterBottomPanel === mmHeight) {
                    this.productDataService.updateProductBottomPanel(mmHeight);
                } else {
                    decimeterBottomSize = this.configuratorHeaderService.getBottomPanelInDecimeterBasedOnMillimeters(millimeterBottomPanel);
                    this.productDataService.updateProductBottomPanel(millimeterBottomPanel);
                }

                if (initialBottomPanelSize) {
                    decimeterBottomSize = this.configuratorHeaderService.getBottomPanelInDecimeterBasedOnMillimeters(initialBottomPanelSize);
                    this.productDataService.updateProductBottomPanel(initialBottomPanelSize);
                }
                this.UIService.replaceSelectOptions(predefinedBottomPanelSelector, bottomPanelSizes, decimeterBottomSize);
            }
        } else {
            customWidthSelector.value = initialWidthInMillimeter ?? this.productDataStore.getAttributeByName('width');
            this.productDataService.updateProductWidth(initialWidthInMillimeter);
            customHeightSelector.value = initialHeightInMillimeter ?? this.productDataStore.getAttributeByName('height');
            this.productDataService.updateProductHeight(initialHeightInMillimeter);

            if (this.productDataService.canHaveBottomPanel()) {
                customBottomPanelSelector.value = this.productDataStore.getAttributeByName('height');

                if (initialBottomPanelSize) {
                    customBottomPanelSelector.value = initialBottomPanelSize;
                    this.productDataService.updateProductBottomPanel(initialBottomPanelSize);
                }
            }
        }

        this.validateBasementWindowRule();
        this.validateDimensionColorRule();
        this.accessoryRulesService.validate();
        this.shapeService.setShapeObject();

        predefinedWidthsSelector.addEventListener('change', event => {
            const predefinedWidthSelector: any = event.target;
            const mmWidth = this.configuratorHeaderService.calculateDimensionValue(parseInt(predefinedWidthSelector.value));
            this.productDataService.updateProductWidth(mmWidth);

            const currentHeight = predefinedHeightsSelector.value;
            const heights = this.configuratorHeaderService.getAvailableHeightsByWidth(parseInt(predefinedWidthSelector.value));
            heights.sort((a, b) => a - b);
            const height = this.configuratorHeaderService.getDmHeightBasedOnWidth(predefinedWidthSelector.value, parseInt(currentHeight));
            this.UIService.replaceSelectOptions(predefinedHeightsSelector, heights, height);
            const mmHeight = this.configuratorHeaderService.calculateDimensionValue(parseInt(height));
            this.productDataService.updateProductHeight(mmHeight);
            this.shapeService.setShapeObject();

            if (this.productDataService.canHaveBottomPanel()) {
                if (predefinedBottomPanelSelector.value === this.FULL_GLASS_OPTION) {
                    const mmHeight = this.configuratorHeaderService.calculateMillimetersFromDecimeters(height);
                    this.productDataService.updateProductBottomPanel(mmHeight);
                }
            }
            this.validateBasementWindowRule();
            this.validateDimensionColorRule();
            this.accessoryRulesService.validate();
            this.turnProductIntoCasementWindow();
            this.productDataService.updateProductDrawing();
            this.eventService.emit('sizeChange');
            this.productDataService.refreshPrice();
        });
        predefinedHeightsSelector.addEventListener('change', event => {
            const predefinedHeightSelector: any = event.target;
            const mmHeight = this.configuratorHeaderService.calculateDimensionValue(parseInt(predefinedHeightSelector.value));
            this.productDataService.updateProductHeight(mmHeight);
            this.shapeService.setShapeObject();

            if (this.productDataService.canHaveBottomPanel()) {
                if (predefinedBottomPanelSelector.value === this.FULL_GLASS_OPTION) {
                    this.productDataService.updateProductBottomPanel(mmHeight);
                }
            }
            this.validateBasementWindowRule();
            this.validateDimensionColorRule();
            this.accessoryRulesService.validate();
            this.turnProductIntoCasementWindow();
            this.productDataService.updateProductDrawing();
            this.eventService.emit('sizeChange');
            this.productDataService.refreshPrice();
        });

        if (this.productDataService.canHaveBottomPanel()) {
            predefinedBottomPanelSelector.addEventListener('change', event => {
                const predefinedBottomPanelSelector: any = event.target;
                if (predefinedBottomPanelSelector.value === this.FULL_GLASS_OPTION) {
                    this.productDataService.updateProductBottomPanel(this.productDataStore.getAttributeByName('height'));
                } else {
                    const mmBottomPanel = this.configuratorHeaderService.calculateDimensionValue(parseInt(predefinedBottomPanelSelector.value));
                    this.productDataService.updateProductBottomPanel(mmBottomPanel);
                }
            });
        }

        customWidthSelector.addEventListener('change', event => {
            // @ts-ignore
            const customWidthSelector: HTMLInputElement = event.target;
            const mmWidth = this.configuratorHeaderService.validateSelectedWidth(parseInt(customWidthSelector.value));
            customWidthSelector.value = mmWidth.toString();
            this.productDataService.updateProductWidth(mmWidth);

            // after we check and set the with we need to check height as well because it depends on width
            const customHeightSelector: HTMLInputElement = this.UIService.getTemplateInput('productCustomHeight');
            const mmHeight = this.configuratorHeaderService.validateSelectedHeight(parseInt(customHeightSelector.value), mmWidth);
            customHeightSelector.value = mmHeight.toString();
            this.productDataService.updateProductHeight(mmHeight);
            this.shapeService.setShapeObject();

            if (this.productDataService.canHaveBottomPanel()) {
                if (parseInt(customBottomPanelSelector.value) === 0) {
                    this.productDataService.updateProductBottomPanel(mmHeight);
                }
            }
            this.validateBasementWindowRule();
            this.validateDimensionColorRule();
            this.accessoryRulesService.validate();
            this.turnProductIntoCasementWindow();
            this.UIService.refreshElementsInModule('configuratorHeader');
            this.productDataService.updateProductDrawing();
            this.eventService.emit('sizeChange');
            this.productDataService.refreshPrice();
        });
        customHeightSelector.addEventListener('change', event => {
            const customWidthSelector: HTMLInputElement = this.UIService.getTemplateInput('productCustomWidth');
            const mmWidth = customWidthSelector.value;
            // @ts-ignore
            const customHeightSelector: any = event.target;
            const mmHeight = this.configuratorHeaderService.validateSelectedHeight(parseInt(customHeightSelector.value), parseInt(mmWidth));
            customHeightSelector.value = mmHeight.toString();
            this.productDataService.updateProductHeight(mmHeight);
            this.shapeService.setShapeObject();

            if (this.productDataService.canHaveBottomPanel()) {
                if (parseInt(customBottomPanelSelector.value) === 0) {
                    this.productDataService.updateProductBottomPanel(mmHeight);
                }
            }
            this.validateBasementWindowRule();
            this.validateDimensionColorRule();
            this.accessoryRulesService.validate();
            this.turnProductIntoCasementWindow();
            this.UIService.refreshElementsInModule('configuratorHeader');
            this.productDataService.updateProductDrawing();
            this.eventService.emit('sizeChange');
            this.productDataService.refreshPrice();
        });

        if (this.productDataService.canHaveBottomPanel()) {
            customBottomPanelSelector.addEventListener('change', event => {
                const customBottomPanelSelector: any = event.target;
                let bottomPanelValue = customBottomPanelSelector.value;

                if (bottomPanelValue === this.FULL_GLASS_OPTION || parseInt(bottomPanelValue) === 0) {
                    bottomPanelValue = this.productDataStore.getAttributeByName('height');
                }
                bottomPanelValue = this.configuratorHeaderService.validateSelectedBottomPanelHeight(bottomPanelValue);
                customBottomPanelSelector.value = bottomPanelValue.toString();
                this.productDataService.updateProductBottomPanel(bottomPanelValue);

                this.UIService.refreshElementsInModule('configuratorHeader');
            });
        }
    }

    /*
     * In case of circle product we just want to set width because height is just the same
     * So we use width dimension to set height
     * To be honest we should set here diameter or radius, but for now we set "width" and we must live with it :)
     */
    private initCircleSizesModule(): void
    {
        const selectedUnit = this.productDataStore.getSelectedOptionData('unit');
        const predefinedWidthsSelector = this.UIService.getTemplateInput('productPredefinedWidth');
        const customWidthSelector = this.UIService.getTemplateInput('productCustomWidth');

        this.updateDimensionSelectorsTemplateFlags(selectedUnit.attributes.type);

        if (selectedUnit.attributes.type === 'module') {
            const widths = this.configuratorHeaderService.getAvailableWidths();

            widths.forEach((width) => {
                this.UIService.createElement(predefinedWidthsSelector, 'option', width);
            });

            const initialWidth = widths[0];
            this.UIService.replaceSelectOptions(predefinedWidthsSelector, widths);
            const initialMillimeterWidth = this.configuratorHeaderService.calculateDimensionValue(initialWidth);
            this.productDataService.updateProductWidth(initialMillimeterWidth);
            this.productDataService.updateProductHeight(initialMillimeterWidth);
        } else {
            customWidthSelector.value = this.productDataStore.getAttributeByName('width');
        }

        this.shapeService.setShapeObject();

        predefinedWidthsSelector.addEventListener('change', event => {
            const predefinedWidthSelector: any = event.target;
            const mmWidth = this.configuratorHeaderService.calculateDimensionValue(parseInt(predefinedWidthSelector.value));
            this.productDataService.updateProductWidth(mmWidth);
            this.productDataService.updateProductHeight(mmWidth);
            this.shapeService.setShapeObject();

            this.validateBasementWindowRule();
            this.validateDimensionColorRule();
            this.accessoryRulesService.validate();

            this.turnProductIntoCasementWindow();
            this.productDataService.updateProductDrawing();
            this.eventService.emit('sizeChange');
            this.productDataService.refreshPrice();

            this.UIService.refreshElementsInModule('configuratorHeader');
        });

        customWidthSelector.addEventListener('change', event => {
            // @ts-ignore
            const customWidthSelector: HTMLInputElement = event.target;
            const mmWidth = this.configuratorHeaderService.validateSelectedWidth(parseInt(customWidthSelector.value));
            customWidthSelector.value = mmWidth.toString();
            this.productDataService.updateProductWidth(mmWidth);
            this.productDataService.updateProductHeight(mmWidth);
            this.shapeService.setShapeObject();

            this.validateBasementWindowRule();
            this.validateDimensionColorRule();
            this.accessoryRulesService.validate();

            this.turnProductIntoCasementWindow();
            this.productDataService.updateProductDrawing();
            this.eventService.emit('sizeChange');
            this.productDataService.refreshPrice();

            this.UIService.refreshElementsInModule('configuratorHeader');
        });

    }

    private selectShapeType(shapeType)
    {
        if (shapeType == '') {
            return;
        }
        const predefinedShapesInputs = this.UIService.getElementsByAttribute('nf-template-action', 'selectPredefinedPolygonShape');

        predefinedShapesInputs.forEach((shapeInput) => {
            shapeInput.classList.remove('--checked-item');
            if (this.UIService.getAttributeFromElement(shapeInput, 'nf-option-id') == shapeType) {
                shapeInput.classList.add('--checked-item');
            }
        });
    }

    private getSelectedPredefinedShape()
    {
        const predefinedShapesInput = this.UIService.getElementBySelector(".--checked-item[nf-template-action=selectPredefinedPolygonShape]");
        if (predefinedShapesInput === undefined) {
            return "";
        }

        return predefinedShapesInput.getAttribute('nf-option-id');
    }

    disableEnablePredefinedPolygonShapeInputs(shapeType) {
        const h1SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH1Size');
        const h2SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH2Size');
        const h3SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH3Size');
        const s1SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS1Size');
        const s2SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS2Size');
        const s3SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS3Size');

        h1SizeInput.disabled = false;
        h2SizeInput.disabled = false;
        h3SizeInput.disabled = false;
        s1SizeInput.disabled = false;
        s2SizeInput.disabled = false;
        s3SizeInput.disabled = false;

        switch (shapeType) {
            case 'SLT':
                s2SizeInput.disabled = true;
                s3SizeInput.disabled = true;
                h2SizeInput.disabled = true;
                break;
            case 'SRT':
                s1SizeInput.disabled = true;
                s2SizeInput.disabled = true;
                h3SizeInput.disabled = true;
                break;
            case 'SLS':
                s3SizeInput.disabled = true;
                h2SizeInput.disabled = true;
                h3SizeInput.disabled = true;
                break;
            case 'SRS':
                s1SizeInput.disabled = true;
                h2SizeInput.disabled = true;
                h3SizeInput.disabled = true;
                break;
            case 'SLC':
                s3SizeInput.disabled = true;
                h2SizeInput.disabled = true;
                break;
            case 'SRC':
                s1SizeInput.disabled = true;
                h3SizeInput.disabled = true;
                break;
            case 'DLT':
                s2SizeInput.disabled = true;
                break;
            case 'DLS':
                h2SizeInput.disabled = true;
                h3SizeInput.disabled = true;
                break;
        }
    }

    private setShapeDimension(dimensionName: string, input)
    {
        const val = this.shapeService.validateShapeDimension(dimensionName, +input.value);
        if (val !== (+input.value)) {
            input.value = val;
        }
        this.shapeService.setDimension(dimensionName, val);
    }

    private initPolygonSizesModule()
    {
        const h1SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH1Size');
        const h2SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH2Size');
        const h3SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH3Size');
        const s1SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS1Size');
        const s2SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS2Size');
        const s3SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS3Size');

        if (!this.UIService.isInEditMode()) {
            this.productDataStore.setAttributeByName('width', this.productDataStore.getAttributeByName('minWidth'));
            this.productDataStore.setAttributeByName('height', this.productDataStore.getAttributeByName('minHeight'))
        } else {
            this.selectShapeType(this.productDataStore.getProductShapeType());
        }
        this.shapeService.setShapeObject();
        const shapeType = this.getSelectedPredefinedShape();
        this.shapeService.setZeroSizesForPredefinedPolygonShape(shapeType);
        this.disableEnablePredefinedPolygonShapeInputs(shapeType);
        this.updatePolygonInputsByShape(this.shapeService.getShape());

        h1SizeInput.addEventListener('change', event => {
            const input: any = event.target;
            this.setShapeDimension('h1', input);
            this.productDataService.updateProductHeight(this.shapeService.getMaximumShapeHeight());
            this.productDataService.updateProductDrawing();
            this.productDataService.refreshPrice();
        });

        h2SizeInput.addEventListener('change', event => {
            const input: any = event.target;
            this.setShapeDimension('h2', input);
            this.productDataService.updateProductHeight(this.shapeService.getMaximumShapeHeight());
            this.productDataService.updateProductDrawing();
            this.productDataService.refreshPrice();
        });

        h3SizeInput.addEventListener('change', event => {
            const input: any = event.target;
            this.setShapeDimension('h3', input);
            this.productDataService.updateProductHeight(this.shapeService.getMaximumShapeHeight());
            this.productDataService.updateProductDrawing();
            this.productDataService.refreshPrice();
        });

        s1SizeInput.addEventListener('change', event => {
            const input: any = event.target;
            this.setShapeDimension('s1', input);
            this.productDataService.updateProductWidth(this.shapeService.getShapeWidth());
            this.productDataService.updateProductDrawing();
            this.productDataService.refreshPrice();
        });

        s2SizeInput.addEventListener('change', event => {
            const input: any = event.target;
            this.setShapeDimension('s2', input);
            this.productDataService.updateProductWidth(this.shapeService.getShapeWidth());
            this.productDataService.updateProductDrawing();
            this.productDataService.refreshPrice();
        });

        s3SizeInput.addEventListener('change', event => {
            const input: any = event.target;
            this.setShapeDimension('s3', input);
            this.productDataService.updateProductWidth(this.shapeService.getShapeWidth());
            this.productDataService.updateProductDrawing();
            this.productDataService.refreshPrice();
        });
    }

    private selectDimensionsUnit(selectedUnitElement)
    {
        const selectedUnitId = Number.parseInt(this.UIService.getAttributeFromElement(selectedUnitElement, 'nf-option-id'));

        this.updateDimensionUnitSelector(selectedUnitId);

        const selectedUnit = this.productDataStore.getAvailableOptionByNameAndId('unit', selectedUnitId);
        this.updateDimensionSelectorsTemplateFlags(selectedUnit.attributes.type);

        this.productDataService.updateSelectedOptionByName('unit', selectedUnit.id);

        const customWidthSelector: HTMLInputElement = this.UIService.getTemplateInput('productCustomWidth');
        const customHeightSelector: HTMLInputElement = this.UIService.getTemplateInput('productCustomHeight');
        const predefinedWidthsSelector: HTMLInputElement = this.UIService.getTemplateInput('productPredefinedWidth');
        const predefinedHeightsSelector: HTMLInputElement = this.UIService.getTemplateInput('productPredefinedHeight');
        const predefinedBottomPanelSelector: HTMLInputElement = this.UIService.getTemplateInput('predefinedBottomPanelSize');
        const customBottomPanelSelector: HTMLInputElement = this.UIService.getTemplateInput('customBottomPanelSize');

        let dmWidth;
        let mmWidth;
        let dmHeight;
        let mmHeight;


        if (selectedUnit.attributes.type === 'module') {
            dmWidth = this.configuratorHeaderService.getWidthInDecimeterBasedOnMillimeters(customWidthSelector.value);

            // @todo: stupid condition for roof window where predefined dimensions are in mm instead of dm
            // @todo: in future we could refactor and use some unit classes to make proper calculations and use strategy pattern
            if (this.productDataService.isRoofWindow()) {
                mmWidth = dmWidth;
            } else {
                mmWidth = this.configuratorHeaderService.calculateMillimetersFromDecimeters(dmWidth);
            }
            const widths = this.configuratorHeaderService.getAvailableWidths();

            this.UIService.replaceSelectOptions(predefinedWidthsSelector, widths);
            predefinedWidthsSelector.value = dmWidth.toString();
            this.productDataService.updateProductWidth(mmWidth);

            // this one is because we don't use height on circle product (width and height is just the same)
            if (!this.productDataService.isCircleProduct()) {
                dmHeight = this.configuratorHeaderService.getHeightInDecimeterBasedOnMillimeters(dmWidth, customHeightSelector.value);

                // @todo: stupid condition for roof window where predefined dimensions are in mm instead of dm
                // @todo: in future we could refactor and use some unit classes to make proper calculations and use strategy pattern
                if (this.productDataService.isRoofWindow()) {
                    mmHeight = dmHeight;
                } else {
                    mmHeight = this.configuratorHeaderService.calculateMillimetersFromDecimeters(dmHeight);
                }
                const heights = this.configuratorHeaderService.getAvailableHeightsByWidth(dmWidth);
                heights.sort((a, b) => a - b);
                this.UIService.replaceSelectOptions(predefinedHeightsSelector, heights);
                predefinedHeightsSelector.value = dmHeight.toString();
                this.productDataService.updateProductHeight(mmHeight);
                if (this.productDataService.canHaveBottomPanel()) {
                    const millimeterBottomPanel = this.productDataStore.getAttributeByName('bottomPanel');
                    if (millimeterBottomPanel === mmHeight) {
                        predefinedBottomPanelSelector.value = this.FULL_GLASS_OPTION;
                        this.productDataService.updateProductBottomPanel(mmHeight);
                    } else {
                        const dmBottomPanel = this.configuratorHeaderService.getBottomPanelInDecimeterBasedOnMillimeters(millimeterBottomPanel);
                        predefinedBottomPanelSelector.value = dmBottomPanel.toString();
                        this.productDataService.updateProductBottomPanel(millimeterBottomPanel);
                    }
                }
            } else {
                this.productDataService.updateProductHeight(mmWidth);
            }
        } else {
            dmWidth = +predefinedWidthsSelector.value;

            // @todo: stupid condition for roof window where predefined dimensions are in mm instead of dm
            // @todo: in future we could refactor and use some unit classes to make proper calculations and use strategy pattern
            if (this.productDataService.isRoofWindow()) {
                mmWidth = dmWidth;
            } else {
                mmWidth = this.configuratorHeaderService.calculateMillimetersFromDecimeters(dmWidth);
            }
            customWidthSelector.value = mmWidth.toString();
            this.productDataService.updateProductWidth(mmWidth);

            // this one is because we don't use height on circle product (width and height is just the same)
            if (!this.productDataService.isCircleProduct()) {
                dmHeight = +predefinedHeightsSelector.value;

                // @todo: stupid condition for roof window where predefined dimensions are in mm instead of dm
                // @todo: in future we could refactor and use some unit classes to make proper calculations and use strategy pattern
                if (this.productDataService.isRoofWindow()) {
                    mmHeight = dmHeight;
                } else {
                    mmHeight = this.configuratorHeaderService.calculateMillimetersFromDecimeters(dmHeight);
                }
                customHeightSelector.value = mmHeight.toString();
                this.productDataService.updateProductHeight(mmHeight);

                if (this.productDataService.canHaveBottomPanel()) {
                    const mmBottomSize = this.productDataStore.getAttributeByName('bottomPanel')
                    if (mmBottomSize === mmHeight) {
                        customBottomPanelSelector.value = mmHeight.toString();
                    } else {
                        customBottomPanelSelector.value = mmBottomSize.toString();
                        this.productDataService.updateProductBottomPanel(mmBottomSize);
                    }
                }
            } else {
                this.productDataService.updateProductHeight(mmWidth);

            }
        }
        this.shapeService.setShapeObject();
        this.validateBasementWindowRule();
        this.validateDimensionColorRule();
        this.accessoryRulesService.validate();
        this.UIService.refreshTemplate('configuratorHeader');
    }

    private initPolygonPredefinedShapes()
    {
        const predefinedShapesInputs = this.UIService.getElementsByAttribute('nf-template-action', 'selectPredefinedPolygonShape');

        predefinedShapesInputs.forEach((shapeInput) => {
            shapeInput.addEventListener('click', (event: any) => {
                const selectedOption: any = event.currentTarget;
                const selectedShapeType = this.UIService.getAttributeFromElement(selectedOption, 'nf-option-id');
                this.productDataStore.setProductShapeType(selectedShapeType);
                this.UIService.resetSelection(predefinedShapesInputs);
                selectedOption.classList.add('--checked-item');

                this.shapeService.setPredefinedPolygonShape(selectedShapeType);
                this.updatePolygonInputsByShape(this.shapeService.getShape());
                this.disableEnablePredefinedPolygonShapeInputs(selectedShapeType);
                this.productDataService.updateProductWidth(this.shapeService.getShapeWidth());
                this.productDataService.updateProductHeight(this.shapeService.getMaximumShapeHeight());
                this.productDataService.updateProductDrawing();
                this.productDataService.refreshPrice();
            });
        });
    }

    private updatePolygonInputsByShape(shape: ShapeInterface)
    {
        const h1SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH1Size');
        const h2SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH2Size');
        const h3SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonH3Size');
        const s1SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS1Size');
        const s2SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS2Size');
        const s3SizeInput: HTMLInputElement = this.UIService.getTemplateInput('polygonS3Size');

        h1SizeInput.value = this.productDataStore.getProductShapeDimension('h1').toString();
        h2SizeInput.value = this.productDataStore.getProductShapeDimension('h2').toString();
        h3SizeInput.value = this.productDataStore.getProductShapeDimension('h3').toString();
        s1SizeInput.value = this.productDataStore.getProductShapeDimension('s1').toString();
        s2SizeInput.value = this.productDataStore.getProductShapeDimension('s2').toString();
        s3SizeInput.value = this.productDataStore.getProductShapeDimension('s3').toString();
    }

    private updateDimensionSelectorsTemplateFlags(unitType: string): void
    {
        if (unitType === 'module') {
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'predefinedDimensionInfo', true);
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'customDimensionsInfo', false);
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'predefinedDimensionSelect', true);
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'customDimensionSelect', false);
        } else {
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'predefinedDimensionInfo', false);
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'customDimensionsInfo', true);
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'predefinedDimensionSelect', false);
            this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'customDimensionSelect', true);
        }
    }

    private turnProductIntoCasementWindow()
    {
        if (this.productDataService.canBeTurnedIntoCasementWindow()) {
            const canTurnIntoCasement = this.validateCasementWindowDimensionsRatio();
            if (canTurnIntoCasement) {
                if (!this.productDataService.currentFunctionIsCasementWindow()) {
                    this.productDataService.updateSelectedOptionByName('handlePosition', this.TOP_HANDLE_POSITION_ID);
                    this.productDataService.updateSelectedOptionByName('hingeSide', this.BOTTOM_HINGE_SIDE_ID);
                    this.productDataStore.setAttributeByName('windowFunctionId', this.CASEMENT_WINDOW_FUNCTION_ID);

                    this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'casementWindowModal', true);
                    this.appStateService.setAppSettingTemplateFlag('handles', 'showHandlePositionSelector', true);
                    this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'hingeSideSelector', false);
                    this.UIService.refreshTemplate('configuratorHeader');
                    this.UIService.refreshTemplate('handles');
                    // @todo: is this ok?
                    this.handleUIService.refreshSelectedOptions();
                }
            } else {
                const defaultHandlePosition = this.productDataStore.getInitialOptionByName('handlePosition')
                const defaultHingeSide = this.productDataStore.getInitialOptionByName('hingeSide')
                this.productDataService.updateSelectedOptionByName('handlePosition', defaultHandlePosition.id);
                this.productDataService.updateSelectedOptionByName('hingeSide', defaultHingeSide.id, true, true);
                this.updateHingeSideSelector();

                this.productDataStore.setAttributeByName('windowFunctionId', this.productDataStore.getInitialAttributeByName('windowFunctionId'));
                this.appStateService.setAppSettingTemplateFlag('handles', 'showHandlePositionSelector', false);
                this.appStateService.setAppSettingTemplateFlag('configuratorHeader', 'hingeSideSelector', true);
                this.UIService.refreshTemplate('configuratorHeader');
                this.UIService.refreshTemplate('handles');
            }
        }
    }

    private validateCasementWindowDimensionsRatio(): boolean
    {
        const width = this.productDataStore.getAttributeByName('width');
        const height = this.productDataStore.getAttributeByName('height');
        return height <= width * 0.8;
    }

    private initializeQuantity()
    {
        let currentQuantity = this.productDataStore.getAttributeByName('quantity');

        if (
            !Number.isInteger(currentQuantity) ||
            Number.isInteger(currentQuantity) &&
            currentQuantity < 1
        ) {
            currentQuantity = 1;
        }
        const inputs = this.UIService.getElementsByAttribute('nf-template-input', 'productQuantity');

        inputs.forEach(element => {
            element.value = currentQuantity;

            element.addEventListener('input', () => {
                let newQuantity = Number.parseInt(element.value);

                if (!Number.isInteger(newQuantity)) {
                    newQuantity = 1;
                    element.value = 1;
                }
                this.productDataStore.setAttributeByName('quantity', newQuantity);
                this.priceService.recalculatePriceBasedOnQuantity(newQuantity);
            });
        });
    }

    setDefaultColorBasedOnAssociation()
    {
        let configId = this.productDataStore.getSelectedOptionByName('configuration').id;
        let colorId: any = localStorage.getItem('associatedConfigurationColor-' + configId);

        if (typeof colorId === 'undefined' || colorId === null || colorId === '') {
            return;
        }

        localStorage.removeItem('associatedConfigurationColor-' + configId);

        colorId = parseInt(colorId);
        const colors: Array<any> = this.productDataStore.getAvailableOptionsByName('color');
        const colorFound = colors.find(color => { return color.id === colorId});

        if (typeof colorFound === 'undefined') {
            return;
        }

        this.productDataService.updateSelectedOptionByName('inner', colorId, true, true);
        this.productDataService.updateSelectedOptionByName('outer', colorId, true, true);
    }

    getDimensionsBasedOnAssociatedProductSize(): {width: number, height: number}
    {
        let configId = this.productDataStore.getSelectedOptionByName('configuration').id;
        let size = localStorage.getItem('associatedConfigurationSize-' + configId);

        if (typeof size === 'undefined' || size === null || size === '') {
            return;
        }

        localStorage.removeItem('associatedConfigurationSize-' + configId);

        let dimensions = size.split('x');
        let widthDimension = parseInt(dimensions[0]);
        let heightDimension = parseInt(dimensions[1]);

        if (dimensions.length === 2) {
            if (widthDimension % 100 === 0 && heightDimension % 100 === 0) {
                return {
                    width: widthDimension,
                    height: heightDimension
                };
            } else {
                return {
                    width: Math.round(widthDimension),
                    height: Math.round(heightDimension)
                };
            }
        }
    }

    getDimensionsFromDifferentSerie()
    {
        return JSON.parse(localStorage.getItem('shape')) ?? null;
    }

    clearDimensionsFromDifferentSerieLocalStorage() {
        localStorage.removeItem('shape');
    }

    initializeSaveAssociatedProductUrl()
    {
        const button = this.UIService.getElementByAttribute('nf-template-action', 'saveAssociatedSizeForLinkedProduct');

        button.addEventListener('click', (event: any) => {
            event.preventDefault();

            this.saveAssociatedSizeForLinkedProduct();
            const url = this.UIService.getAttributeFromElement(event.currentTarget, 'href');
            window.location = url;
        })
    }

    saveAssociatedSizeForLinkedProduct()
    {
        let configId = this.productDataStore.getProductInfoAttributeByName('associatedConfigurationId');
        let currentWidth = this.productDataStore.getAttributeByName('width');
        let currentHeight = this.productDataStore.getAttributeByName('height');
        localStorage.setItem('associatedConfigurationSize-' + configId, currentWidth + "x" + currentHeight);
    }

    validateBasementWindowRule()
    {
        const width = this.productDataStore.getAttributeByName('width');
        const height = this.productDataStore.getAttributeByName('height');
        if (
            this.productDataStore.getProductInfoAttributeByName('productEligibleForBasementWindowRule') &&
            new BasementWindowRulesService().areConditionsMet(width, height)
        ) {
            this.UIService.displayTopNotification('basementWindowRuleNotice');
        }
    }


    validateDimensionColorRule() {
        const productId = this.productDataStore.getProductId();
        const width = this.productDataStore.getAttributeByName('width');
        const height = this.productDataStore.getAttributeByName('height');
        const outerColor = this.productDataStore.getSelectedOptionByName('outer');

        if (!!this.customDimensionColorRuleService.checkProductLimitation(productId, width, height, outerColor)) {
            this.UIService.displayTopNotification('dimensionColorRuleNotice');
        }
    }

    addToCartPinterestEvent() {
        // @ts-ignore
        window.pintrk('track', 'AddToCart', {
            // @todo: fix this one
            //value: this.dataService.price,
            order_quantity: this.productDataStore.getAttributeByName('quantity'),
            currency: 'SEK'
        });
    }

    addToCartGTMEvent() {
        // @ts-ignore
        window.googleTagManagerService.pushAddToCartDataLayer(
            // @todo: fix this one
            //this.dataService.price,
            this.productDataStore.getAttributeByName('articleNumber'),
            this.productDataStore.getProductInfoAttributeByName('configurationName'),
            this.productDataStore.getProductInfoAttributeByName('productCategory'),
            this.productDataStore.getAttributeByName('quantity'),
        );
    }

    /**
     * @todo: fix implementation
     */
    addToCart()
    {}

    // todo: fix implementation
    blockAddToCartButton()
    {

    }

    private updateDimensionUnitSelector(selectedUnitId)
    {
        // check selected unit on template
        const inputSelectors = this.UIService.getElementsByAttribute('nf-template-input', 'unitSelector');
        inputSelectors.forEach((selector) => {
            const selectorUnitId = Number.parseInt(this.UIService.getAttributeFromElement(selector, 'nf-option-id'));
            selector.classList.remove('--checked');
            if (selectorUnitId === selectedUnitId) {
                selector.classList.add('--checked');
            }
        });
    }
}
